var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRelated(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45960_84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 10.6667C8.95299 11.0494 9.31826 11.3661 9.73772 11.5953C10.1572 11.8245 10.621 11.9607 11.0978 11.9949C11.5745 12.029 12.0531 11.9602 12.5009 11.7932C12.9488 11.6261 13.3554 11.3647 13.6934 11.0267L15.6934 9.02666C16.3005 8.39799 16.6365 7.55598 16.6289 6.68199C16.6213 5.808 16.2708 4.97196 15.6527 4.35394C15.0347 3.73591 14.1987 3.38535 13.3247 3.37775C12.4507 3.37016 11.6087 3.70614 10.98 4.31333L9.83335 5.45333",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.33334C11.047 8.95058 10.6818 8.63388 10.2623 8.40471C9.84285 8.17554 9.37901 8.03926 8.90224 8.00511C8.42548 7.97097 7.94695 8.03976 7.49911 8.20681C7.05128 8.37387 6.6446 8.63529 6.30668 8.97334L4.30668 10.9733C3.69948 11.602 3.3635 12.444 3.3711 13.318C3.37869 14.192 3.72926 15.028 4.34728 15.6461C4.96531 16.2641 5.80135 16.6147 6.67534 16.6222C7.54933 16.6298 8.39134 16.2939 9.02001 15.6867L10.16 14.5467",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45960_84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelated);
export default __webpack_public_path__ + "static/media/related.c6336977.svg";
export { ForwardRef as ReactComponent };